import get from 'lodash/get'
import * as React from 'react'
import { toast } from 'react-toastify'
import Ui from 'ui'
import Icons from 'ui/Icons'

function BuilderHandoutEditProps({ onUpdateQuestionProps, question }) {
  const fileRef = React.useRef()

  const handleChange = () => {
    const file = get(fileRef, ['current', 'files', 0], null)

    if (!file) {
      toast.error('You need to upload at least one file')
      onUpdateQuestionProps({
        image: null,
        imageToDisplayOnBuilder: null,
      })
      return
    }

    if (file.type !== 'application/pdf') {
      toast.error('You can only upload PDF files')
      fileRef.current.value = ''
      return
    }

    const reader = new FileReader()
    reader.onload = (e) => {
      onUpdateQuestionProps({
        image: file,
        imageToDisplayOnBuilder: e.target.result,
      })
    }
    reader.readAsDataURL(file)
  }

  function onDeletePress() {
    onUpdateQuestionProps({
      image: null,
      imageToDisplayOnBuilder: null,
    })
  }

  if (question?.imageToDisplayOnBuilder) {
    return (
      <div className="space-x-2">
        <Ui.ButtonClear className="h-10 space-x-2 border" onClick={() => null}>
          <Icons.Check color="text-green-400" />
          <span>File Uploaded</span>
        </Ui.ButtonClear>
        <Ui.ButtonClear
          className="h-10 w-10 space-x-2 border px-2"
          onClick={onDeletePress}
        >
          <Icons.Refresh size={5} />
        </Ui.ButtonClear>
      </div>
    )
  }

  return (
    <div className="pt-2">
      <Ui.QuestionLabel>PDF File</Ui.QuestionLabel>
      <Ui.FileInput accept=".pdf" onChange={handleChange} ref={fileRef} />
    </div>
  )
}

export default BuilderHandoutEditProps
